// extracted by mini-css-extract-plugin
module.exports = {"layout":"app_layout__RrHgH","content":"app_content__ckDFI","footer":"app_footer__3qb7a"};